// extracted by mini-css-extract-plugin
export default {"secondary":"secondary-button_secondary__9anrv","secondary__icon":"secondary-button_secondary__icon__X9ek5"};